import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { EventEmitterTicketsBo, GetTicketsBO } from '../ticket.model';
import { GlobalComponent } from 'src/app/global/global.component';
import { Observable, Subject } from 'rxjs';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent, IFilter, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { ColumnChangeBO } from '../../eligibility270/eligibility270.model';
import { columnWidth } from '../../icd10/icd10.model';

import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { CommonApiService } from 'src/app/commonapiservice';
import { TicketViewService } from './ticket-view.service';
import { EnvironmentService } from 'src/app/environment.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-ticket-view',
  templateUrl: './ticket-view.component.html',
  styleUrls: ['./ticket-view.component.scss']
})
export class TicketViewComponent implements OnInit {
  @Input() ViewInput: EventEmitterTicketsBo = new EventEmitterTicketsBo();
  @Output() ViewOutput = new EventEmitter<EventEmitterTicketsBo>();

  ////////////////=======================Grid variable declaration==============================///
  @ViewChild("reportContainer", { static: false }) reportContainer: ElementRef;
  public GridDataList: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  private onDestroy$: Subject<void> = new Subject<void>();

  @ViewChild('childtemplate') public childtemplate: any;
  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('gridcompleted') public gridcompleted: GridComponent;
  public formatOptions: object;


  ColumnArray: columnWidth[];
  filterOptions: FilterSettingsModel;
  initialPage: object;
  filter: IFilter;
  /////////////////=======================================================//////////////////
  ticketstab = "Pending";
  ListSendBO = new GetTicketsBO();
  filterItems: any = ["Type", "Priority"];
  DeleteRecordId: any

  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: number = 0;
  isEnabledExcel: boolean = false;
  arraycol: any = [];
  SearchText: string = '';
  SearchColumn: { [key: string]: string } = { '': '' };
  StatusList: any = [];
  PriorityList: any = [];
  TypesList: any = [];
  EmployeeDropdown: any = [];
  
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public toolbar: ToolbarItems[];
  public filterSettings: object;
  AllClientDropDownListwithStatus : any;
  @Input() clientTab: string;
  constructor(
    public global: GlobalComponent, public toastrService: ToastrService,
    public EService: EnvironmentService, public CommonAPI: CommonApiService, public service: TicketViewService) {

    this.GridDataList = service
  }

  ngOnInit(): void {
    console.log(this.clientTab,"ticket client")
    
 if (this.global.isTicketNewTab == true) {
  this.ListSendBO.clientId =  this.global.EventClientid;
  localStorage.removeItem('cfss_TicketNewTabFunctionality')
  
 }
    this.getpermission();
    this.getEmployeeDropdown();
    this.getPriorityList();
    this.getTickettypes();
    this.getStatus();
    this.getAllClient();

    this.filterOptions = { type: 'Menu' };
    this.filter = {
      type: 'menu'
    };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy h:mm:ss a' };
    this.initialPage = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 250,
      pageSize: this.pageSizes[5],
      pageSizes: this.pageSizes,
    };
    this.toolbar = ["ColumnChooser"];
    this.filterSettings = { type: "Menu" };
    this.filter = {
      type: "Excel",
    };
    this.GetTicketsList();
  }
 
    fp:any;
  getpermission() {
     let params = new URLSearchParams();
      params.append("pagecode", "TICKET");    
     let url = "api/FunctionPermission/getfunctionpermissionemployee?";
     this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
       if (data != null) {
         this.fp = data;
       }
       else {
         this.fp = null;
       }
     },
       (err: HttpErrorResponse) => {
         this.fp = null;
       })
   }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.toastrService.success("Copied to clipboard")
    }).catch(err => {
      console.error('Could not copy text: ', err);
    });
  }


  //....................................................AddManualEntry.........................................
  AddManualEntry() {
    this.ViewInput.isEntry = true;
    this.ViewInput.isEdit = false;
    this.ViewOutput.emit(this.ViewInput);
  }
  //.................................................edittickets........................................................
  edittickets(data, args: any) {

    this.ViewInput.isEntry = true;
    this.ViewInput.tickets = data;
    this.ViewInput.isEdit = true;
    this.ViewOutput.emit(this.ViewInput);
  }

  setDefaultValue() {
    this.SearchText = "";
    if (this.SearchColumn == undefined)
      this.SearchColumn = {
        'tickettype': 'TicketType',
      };
  }
  onKeydown(event) {
    if (event.key === "Enter") {
      this.Search();
    }
  }
  Search() {

    this.GetTicketsList()
  }

  //................................................... dataStateChange.................................................

  type: string;
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.ListSendBO.orderColumn = state.sorted[0].name;
        this.ListSendBO.orderType = state.sorted[0].direction === 'descending' ? 'desc' : 'asc';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.ListSendBO.field = state.action.currentFilterObject.field;
      this.ListSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.ListSendBO.operator = state.action.currentFilterObject.operator;
      this.ListSendBO.value = state.action.currentFilterObject.value;
      if (this.ListSendBO.type == "number") {
        this.ListSendBO.value = state.action.currentFilterObject.value.toString();
        this.ListSendBO.field = state.action.currentFilterObject.field;
      }
      else if (this.ListSendBO.type == "date") {
        this.ListSendBO.value = this.global.getDateTimeString(state.action.currentFilterObject.value);
        this.ListSendBO.field = state.action.currentFilterObject.field;
      }
      else {
        this.ListSendBO.value = state.action.currentFilterObject.value;
        this.ListSendBO.field = state.action.currentFilterObject.field;
      }
      this.ListSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.ListSendBO.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.ListSendBO.field = "uniqueTicketId";
        this.ListSendBO.matchCase = false;
        this.ListSendBO.operator = "startswith";
        this.ListSendBO.value = "";
        this.ListSendBO.type = "string";
      }
    }
    if (this.type != "refresh") {
      this.GetTicketsList();
    }
  }

  //.................................................onActionComplete........................................................
  public onActionComplete(args) {
    this.ListSendBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.ListSendBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.grid.columns.forEach((element) => {
        if (
          element.visible == false &&
          element.headerText != "Actions" &&
          element.headerText != ""
        ) {
          hidearr.push(element.headerText);
        }
        if (
          element.visible == true &&
          element.headerText != "Actions" &&
          element.headerText != ""
        ) {
          showarr.push(element.headerText);
        }
      });

      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].Agency.ShowColumns.forEach((old) => {
            showarr.forEach((element) => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });

          this.arraycol[0].Agency.HideColumns.forEach((old) => {
            hidearr.forEach((element) => {
              if (old == element) {
                count = count + 1;
              }
            });
          });

          if (showarr.length != count1 || hidearr.length != count) {
            this.arraycol[0].Agency.ShowColumns = showarr;
            this.arraycol[0].Agency.HideColumns = hidearr;
          }
        }
      }
    }

  
  }


  //.................................................Refresh........................................................
  Refresh() {
    this.ListSendBO = new GetTicketsBO();
    this.ListSendBO.employeeId =null;
    this.ListSendBO.ticketTypeLid =null;
    this.ListSendBO.priorityLid =null;
    this.ListSendBO.statusLid =null;
    this.GetTicketsList();

  }

  //.............................................. openColumnChooser..................................
  show() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }

  //////////////////Get call for tickets
  TicketsList: any = [];
  GetTicketsList() {
    let val = 0;
    let url = "api/Ticket/GetTickets"
    let responseData =
    {
      result: "result",
      count: "count",
    }
     if(this.clientTab == 'clienttab')
     {
      this.ListSendBO.clientId = this.global.clientId;
     }
    this.service.executeViewList(this.ListSendBO)

    this.GridDataList.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.TicketsList = data.result;
      //this.grid.dataSource = data.result;

      val++;
      if (data != null && data != undefined && val == 1) {
        setTimeout(() => {
          // this.getColumnwidth();
        }, 500);

      }
    });
  }
  //.................................................getPriorityList........................................................
  getPriorityList() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "TICKETPRIORITY");
    this.CommonAPI.getDropDownList("TICKETPRIORITY", params, url, "LovDropDown").then(
      (data: any) => {
        this.PriorityList = data;
      },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    );
  }

  //.................................................getPriorityList........................................................
  getTickettypes() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "TICKETTYPE");
    this.CommonAPI.getDropDownList("TICKETTYPE", params, url, "LovDropDown").then(
      (data: any) => {
        this.TypesList = data;

      },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    );
  }

  selectedItem(data) {
    this.DeleteRecordId = data.id;
  }
  Delete() {
    let url = "api/Ticket/SetDeleteFlag?"
    let params = new URLSearchParams();
    params.append("ticketId", this.DeleteRecordId);

    this.CommonAPI.GetFunctionwithResponseTypeText(params, url).subscribe(
      (res) => {
        document.getElementById('OpenDeletetickets').click();
        this.GetTicketsList();


      },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    );

  }

  RestoreTicket() {
    let url = "api/Ticket/SetPendingFlag?"
    let params = new URLSearchParams();
    params.append("ticketId", this.DeleteRecordId);

    this.CommonAPI.GetFunctionwithResponseTypeText(params, url).subscribe(
      (res) => {
        document.getElementById('OpenRestoreAlert').click();
        this.GetTicketsList();


      },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    );

  }
  getEmployeeDropdown() {
    let myParams = new URLSearchParams();
    // myParams.append("LocationId", this.locationId.toString());
    let url = "api/Employee/employeeDropDown?";
    this.CommonAPI
      .GetFunctionwithResponseTypeJson(myParams, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        data.forEach((element) => {
          element.Value = element.Value;
          element.Key = element.Key.toString();
        });
        this.EmployeeDropdown = data;
      });
  }
  getStatus() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "TICKETSTATUS");
    this.CommonAPI.getDropDownList("TICKETSTATUS", params, url, "LovDropDown").then(
      (data: any) => {
        this.StatusList = data;
      },
      (err: any) => {
        this.toastrService.error(err);
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      }
    );
  }
    getAllClient() {
     if(this.clientTab == 'clienttab')
      {
        this.ListSendBO.clientId = this.global.clientId;
      }
    let param = new URLSearchParams();

    let locId;
    if (this.global.globalLocationId != null && this.global.globalLocationId != ''
      && this.global.globalLocationId != undefined) {
      locId = parseInt(this.global.globalLocationId);
    }
    else {
      locId = "00000000-0000-0000-0000-000000000000";
    }
    param.append("LocationId", locId);
    let url = "api/Client/GetAllClientsDropDownbyAgency?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any[]) => {
     this.AllClientDropDownListwithStatus = JSON.parse(JSON.stringify(data));
      this.AllClientDropDownListwithStatus.forEach(record => {
          record.Key = record.id.toString();
          record.Value = record.names + " (" + record.status + ")";
          
          if (record.medicaid) {
            record.Value += " (" + record.medicaid + ")";
          }
        });                  
    })
  }
}

